<script>
    import { onMount } from "svelte";

    export let label;
    export let value;
    export let isDisabled = false;
    let fill = false;
    let focus = false;

    onMount(() => {
        setStatus();
    });

    function setStatus() {
        focus = false;
    }
</script>
<div class="naui-field active">
    <label class:focus={focus}>{label}</label>
    <input class="naui-input w-100"
           type="date"
           bind:value={value}
           on:input
           disabled={isDisabled}
           on:focusin={()=>focus=false}
    />
</div>
